import React, { useEffect, useRef, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import EzTable from "../../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import EzNotFound from "../../../common/EzNotFound";
import { Box, Container, Grid } from "@mui/material";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from "./style";
import EzControlledCalendarWithFloatingLabel from "../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../utils/form/form-utils";
import EzControlledInputWithFloatingLabel from "../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import EzControlledDropDowntWithFloatingLabel from "../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";

import EzControlledMultiSelecttWithFloatingLabel from "../../../common/EzForm/EzControlledMultiSelect/WithFloatingLabel";

import {
  bookingTypeDD,
  listStatusDD,
} from "../ReservationsDailyManifestReport/CreateReservationsDailyManifestReport/constant";
import { ReservationsReservationsBreadcrumb } from "../ReservationsReservations/CreateReservationsReservations/constant";
import { printTableData } from "../../../utils/printUtils";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const ReservationsDailyManifestReport = (props) => {
  const classes = useStyles();
  const {
    fetchReservationsDailyManifestReports,
    tableData,
    setDeleteConfirmationPopupVisibility,
    exportReservationsDailyManifestReport,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateReservationsDailyManifestReport,
    editReservationsDailyManifestReportRoute,
    viewReservationRoute,
    RateNetworkDD,
    locationDD,
    setIsSearch,
    dailyManifestFilters,
    setDailyManifestFilters,
    clearDailyManifestFilters,
    tableColumnFilters,
    setTableColumnFilters,
    clearTableColumnFilters,
    savedTableState,
    onTableStateChange,
  } = props;
  let customFields = {
    endDate: "",
    startDate: "",
    location: dailyManifestFilters?.location || "",
    network: dailyManifestFilters?.network || "",
    status: dailyManifestFilters?.status || 0,
    type: "",
  };
  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      return customFields;
    }, [dailyManifestFilters]),
  });
  const [isCopy, setIsCopy] = useState(false);
  const [isPrintError, setIsPrintError] = useState(false);
  const [areFiltersVisible, toggleFilterState] = useState(true);
  
  // Reset form when filters change (from Redux)
  useEffect(() => {
    if (dailyManifestFilters) {
      reset({
        endDate: "",
        startDate: "",
        location: dailyManifestFilters?.location || "",
        network: dailyManifestFilters?.network || "",
        status: dailyManifestFilters?.status || 0,
        type: "",
      });
    }
  }, [dailyManifestFilters, reset]);
  
  const convertToTSV = (data) => {
    const headers = data.columns.map((item) => item.colLabel).join("\t");
    //const headers = Object.keys(data.rows[0]).join('\t');
    const rows = data.rows
      .map((row) => Object.values(row).join("\t"))
      .join("\n");
    return `${headers}\n${rows}`;
  };
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };
  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => setIsCopy(true));
  };
  useEffect(() => {
    setTimeout(() => setIsCopy(false), 1000);
  }, [isCopy]);
  
  useEffect(() => {
    if (isPrintError) {
      const timer = setTimeout(() => setIsPrintError(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isPrintError]);
  
  const handlePrint = () => {
    const success = printTableData({
      title: "Daily Manifest Report",
      columns: tableData?.columns || [],
      rows: tableData?.rows || [],
      orientation: "landscape",
    });
    if (!success) {
      setIsPrintError(true);
    }
  };

  const handleExport = () => {
    const exportPayload = {
      additinalFilter: dailyManifestFilters,
    };
    exportReservationsDailyManifestReport(exportPayload);
  };

  // Callback to save table column filters when they change
  const handleTableFilterChange = (newFilters) => {
    // Extract just the filter values from the filters object
    const filterValues = {};
    const dateFields = ['bookingDate', 'pickup', 'dropoff'];
    Object.keys(newFilters).forEach(key => {
      if (key !== 'global' && newFilters[key]?.value !== null && newFilters[key]?.value !== undefined) {
        let value = newFilters[key].value;
        // Format date values to YYYY-MM-DD for API
        if (dateFields.includes(key) && value instanceof Date) {
          value = dayjs(value).format('YYYY-MM-DD');
        }
        filterValues[key] = value;
      }
    });
    if (setTableColumnFilters) {
      setTableColumnFilters(filterValues);
    }
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Daily Manifest Report</h4>
            <Button
              label={areFiltersVisible ? "Hide Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary shadow-btn`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div className="buttonarea">
            <div className="create-btn-group">
              {/* {
              screenPermissions?.create && (
                <Button
                  label={"Create Reservations Detail Report"}
                  className={` p-button-raised`}
                  style={{ borderRadius: "0px", }}
                  onClick={handleCreateReservationsDailyManifestReport}
                />
              )
            } */}
            </div>
            <div className="copy-excel-print-group">
              <Button
                label={"Copy"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              <Button
                label={"Excel"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handleExport}
              />
              <Button
                label={"Print"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handlePrint}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();

  const filters = useMemo(() => {
    const getFilterValue = (key) => tableColumnFilters?.[key] ?? null;
    return {
      global: { value: null },
      id: { value: getFilterValue("id"), filterKey: "id" },
      ref: { value: getFilterValue("ref"), filterKey: "ref" },
      networkBookingNo: { value: getFilterValue("networkBookingNo"), filterKey: "networkBookingNo" },
      networkTitle: { value: getFilterValue("networkTitle"), filterKey: "networkTitle" },
      locationTitle: { value: getFilterValue("locationTitle"), filterKey: "locationTitle" },
      vehicle: { value: getFilterValue("vehicle"), filterKey: "vehicle" },
      bookingDate: { value: getFilterValue("bookingDate"), filterKey: "bookingDate" },
      pickup: { value: getFilterValue("pickup"), filterKey: "pickup" },
      dropoff: { value: getFilterValue("dropoff"), filterKey: "dropoff" },
      currencyCode: { value: getFilterValue("currencyCode"), filterKey: "currencyCode" },
      totalAmount: { value: getFilterValue("totalAmount"), filterKey: "totalAmount" },
      days: { value: getFilterValue("days"), filterKey: "days" },
      name: { value: getFilterValue("name"), filterKey: "name" },
      paymentStatus: { value: getFilterValue("paymentStatus"), filterKey: "paymentStatus" },
      rateType: { value: getFilterValue("rateType"), filterKey: "rateType" },
      status: { value: getFilterValue("status"), filterKey: "status" },
    };
  }, [tableColumnFilters]);

  const getToastProps = () => {
    let toastTitle = "";
    if (isPrintError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle:
          "Unable to open print window. Please check your popup blocker settings.",
        shouldShowToast: true,
      };
    }
    if (isCopy) {
      let toastTitle = "Data copied to clipboard!";
      if (!isCopy) {
        toastTitle = "Error while Data copied to clipboard!";
      }

      return {
        severity: isCopy ? TOAST_SEVERITY.SUCCESS : TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };
  const onSubmit = (data) => {
    setDailyManifestFilters(data);
    setIsSearch(true);
    fetchReservationsDailyManifestReports({
      pageNumber: 0,
      pageSize: paginationInfo?.pageSize || 10,
      sortField: "id",
      userId: localStorage.getItem("userId"),
      additinalFilter: data,
    });
  };
  
  const handleResetFilters = () => {
    clearDailyManifestFilters();
    if (clearTableColumnFilters) {
      clearTableColumnFilters();
    }
    setIsSearch(false);
    fetchReservationsDailyManifestReports({
      pageNumber: 0,
      pageSize: paginationInfo?.pageSize || 10,
      sortField: "id",
      userId: localStorage.getItem("userId"),
      additinalFilter: { location: "", network: "", status: 0 },
    });
  };
  const tableProps = {
    columns: tableData?.columns,
    paginationInfo,
    areFiltersVisible,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Daily Manifest Report found.",
    filters,
    loadLazyData: fetchReservationsDailyManifestReports,
    loading: isLoading,
    showMoreActions: false,
    sortField: savedTableState?.sortField || "id",
    initialSortOrder: savedTableState?.sortOrder,
    initialFirst: savedTableState?.first || 0,
    initialRows: savedTableState?.rows || 10,
    setDeleteConfirmationPopupVisibility,
    onEditRecord: editReservationsDailyManifestReportRoute,
    onViewRecord: viewReservationRoute,
    additinalFilter: dailyManifestFilters,
    showViewButton: true,
    showEditButton: false,
    tableColumnFilters,
    setTableColumnFilters,
    clearTableColumnFilters,
    onTableFilterChange: handleTableFilterChange,
    onTableStateChange,
  };
  return (
    <>
      <Container maxWidth="lg">
        <Breadcrumb list={ReservationsReservationsBreadcrumb} />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}

          <div className="form-demo">
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledMultiSelecttWithFloatingLabel
                    name="location"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={locationDD}
                    isError={errors["location"]}
                    errorMsg={getFormErrorMessage("location")}
                    label="Location"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledMultiSelecttWithFloatingLabel
                    name="network"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={RateNetworkDD}
                    isError={errors["network"]}
                    errorMsg={getFormErrorMessage("network")}
                    label="Network"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledDropDowntWithFloatingLabel
                    name="status"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={listStatusDD}
                    isError={errors["status"]}
                    errorMsg={getFormErrorMessage("status")}
                    label="Status"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <div
                    style={{ margin: "0px 0px 0px 10px", maxWidth: "200px", display: "flex", gap: "10px" }}
                  >
                    <Button
                      type="button"
                      label={"Search"}
                      className="p-button-raised"
                      onClick={handleSubmit(onSubmit)}
                    />
                    <Button
                      type="button"
                      label={"Reset"}
                      className="p-button-raised p-button-secondary"
                      onClick={handleResetFilters}
                    />
                  </div>
                </Grid>
              </Grid>
            </form>
          </div>
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box id="printable">
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Daily Manifest Report records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default ReservationsDailyManifestReport;
